module.exports = __webpack_public_path__ + "img/math-1-en.77d5df26.png";